export default {"src":"/_next/static/media/scan.809a3a93.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};